export const initialDoorSystemState = {
    doorsOpen: [false, false, false],
    previousDoorsOpen: [false, false, false],
};
